// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Card_wrapper__ESwwF","disable":"Card_disable__2weAT"};